module.exports = ".overlay {\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 3500;\n  overflow-y: auto; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared-components/overlay/overlay.component.scss
// module id = ./src/app/shared-components/overlay/overlay.component.scss
// module chunks = main